import { Link as RouterLink, NavLink as RouterNavLink } from 'react-router-dom';

export const Link = RouterLink;
export const NavLink = RouterNavLink;
